import { FunctionComponent } from "react";
import ForgotPasswordContainer from "../../../components/ForgotPasswordContainer";

const ForgotPassword: FunctionComponent = ({}) => {
  return <ForgotPasswordContainer />;
};

export default ForgotPassword;
